import React from 'react';

import { signingRecordTypes, additionalAxDocumentTypes } from './actions'


const initialState = {
    isFetching: false,
}


export function signingRecords(state = initialState, action) {

    switch(action.type) {

        case signingRecordTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case signingRecordTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data

            return state


        default:
            return state
    }
}


const axAdditionalDocumentsInitialState = {
    isFetching: false,
    error: false,
    errorMessage: ''
}


export function additionalAxDocuments(state = axAdditionalDocumentsInitialState, action) {

    switch(action.type) {

        case additionalAxDocumentTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case additionalAxDocumentTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data

            return state

        case additionalAxDocumentTypes.ERROR:
            state = {
                ...state, 
                isFetching: false,
                error: true,
                errorMessage: action.data.errorMessage
            }

            return state


        default:
            return state
    }
}